import { useDebounceEffect, useScroll } from 'ahooks';
import { type FC, cloneElement, useState } from 'react';
import { Icon } from '@/components';
import { useAuthLogin } from '@/hooks';
import { openOnline } from '@/utils/index';
import { scrollTo } from '@/utils/scroll';
import styles from './index.less';

const Elevator: FC = () => {
  const { onAuthLogin } = useAuthLogin();
  const scroll = useScroll(document);
  const [isScroll, setIsScroll] = useState<boolean>(false);
  const handleGo = (url: string) => {
    onAuthLogin(() => {
      const { pathname, search } = window.location;
      const path = `${pathname}${search}`;
      if (url !== path) {
        window.open(url);
      }
    });
  };

  const handleAccount = () => {
    handleGo('/manage/ac/account');
  };

  const handleCart = () => {
    handleGo('/cart');
  };

  const handleOnline = () => {
    openOnline();
  };

  const list = [
    {
      icon: <Icon type="icon-icon_gerenzhongxin" />,
      label: '账户信息',
      onClick: handleAccount,
    },
    {
      icon: <Icon type="icon-icon_gouwuche" />,
      label: '购物车',
      onClick: handleCart,
    },
    {
      icon: <Icon type="icon-icon_kefu" />,
      label: '在线客服',
      onClick: handleOnline,
    },
  ];

  useDebounceEffect(
    () => {
      if (scroll?.top && Number(scroll?.top) > 50) {
        setIsScroll(true);
      } else {
        setIsScroll(false);
      }
    },
    [scroll],
    { wait: 300 },
  );

  return (
    <div className={styles.elevators}>
      <ul className={styles.elevator}>
        {list.map((item) => (
          <li
            className={styles.elevatorItem}
            key={item.label}
            onClick={item.onClick}
          >
            {cloneElement(item.icon, {
              className: styles.elevatorIcon,
            })}
          </li>
        ))}
      </ul>
      {isScroll && (
        <ul className={styles.elevator}>
          <li
            className={styles.elevatorItem}
            onClick={() => {
              scrollTo(0, {});
            }}
          >
            <Icon className={styles.elevatorIcon} type="icon-icon_zhiding" />
          </li>
        </ul>
      )}
    </div>
  );
};

export default Elevator;
